<sc-placeholder
  class="ab-footer"
  name="ab-footer"
  [rendering]="rendering"
></sc-placeholder>
